export default {
    blocked: 'user_blocked',
    alreadyExist: 'person_already_exist',
};
